/* eslint-disable */
import { Component } from "react";
import { RendererProvider } from "react-fela";
import { rehydrate } from "fela-dom";
import { createRenderer } from "~/modules/renderer";

const fallbackRenderer = createRenderer();

if (typeof window !== "undefined") {
  // Restore the exact server-side Fela cache embedded by _document.js.
  // fela-dom's rehydrateRules() fails for numeric values because it keys
  // entries from CSS text (post-plugin: "16px") while the renderer keys them
  // from original values (pre-plugin: 16). Restoring the serialized server
  // cache avoids that mismatch and prevents className divergence on hydration.
  const state = window.__FELA_STATE__;
  if (state && state.cache) {
    Object.keys(state.cache).forEach(key => {
      fallbackRenderer.cache[key] = { className: state.cache[key] };
    });
    fallbackRenderer.uniqueRuleIdentifier = state.uid;
  }
  // rehydrate() sets up the DOM subscription so future Fela renders inject
  // new CSS into the existing style nodes rather than creating duplicates.
  rehydrate(fallbackRenderer);
}

export default class FelaProvider extends Component {
  render() {
    const renderer = this.props.renderer || fallbackRenderer;
    return (
      <RendererProvider renderer={renderer}>
        {this.props.children}
      </RendererProvider>
    );
  }
}
